import React from 'react';
import {
  BarChart3,
  ClipboardCheck,
  ClipboardList,
  LayoutDashboard,
  LayoutGrid,
  ListTree,
  Settings2,
} from 'lucide-react';
import { RibbonDesktopButton } from '../../../components/ribbon/DesktopRibbonControls';

export type LstScreen =
  | 'central-gestao'
  | 'meu-padrao'
  | 'cadeia-ajuda'
  | 'construtor'
  | 'auditoria'
  | 'diagnostico'
  | 'configuracao';

interface LstScreenTabsProps {
  screen: LstScreen;
  onChange: (screen: LstScreen) => void;
  /** Esconde abas gerenciais quando o usuário não tem liderados. */
  canAudit: boolean;
  /** Exibe a aba de parametrização apenas para gestão/admin. */
  canConfigure: boolean;
}

const TABS: Array<{ id: LstScreen; label: string; title: string; icon: React.ReactNode }> = [
  {
    id: 'central-gestao',
    label: 'Central',
    title: 'Central de Gestão — Torre de Controle TPL',
    icon: <LayoutDashboard size={18} strokeWidth={1.5} />,
  },
  { id: 'meu-padrao', label: 'Meu Padrão', title: 'Meu Padrão de Trabalho', icon: <ClipboardList size={18} strokeWidth={1.5} /> },
  { id: 'construtor', label: 'Planner', title: 'Planner Heijunka — Centro de Capacidade', icon: <LayoutGrid size={18} strokeWidth={1.5} /> },
  { id: 'auditoria', label: 'Auditoria', title: 'Auditoria de Camada — TPL dos Líderes', icon: <ClipboardCheck size={18} strokeWidth={1.5} /> },
  { id: 'cadeia-ajuda', label: 'Cadeia', title: 'Cadeia de Ajuda — Escalonamento Andon', icon: <ListTree size={18} strokeWidth={1.5} /> },
  { id: 'diagnostico', label: 'Diagnóstico', title: 'Diagnóstico — Julgamento, causas e perdas', icon: <BarChart3 size={18} strokeWidth={1.5} /> },
  { id: 'configuracao', label: 'Engenharia', title: 'Engenharia do Padrão — Projeto do TPL', icon: <Settings2 size={18} strokeWidth={1.5} /> },
];

export const LstScreenTabs: React.FC<LstScreenTabsProps> = ({ screen, onChange, canAudit, canConfigure }) => (
  <div
    className="flex h-full max-w-full shrink-0 items-center gap-0.5 overflow-x-auto pr-2 scrollbar-none"
    style={{
      borderRight: '1px solid var(--border-default, rgba(255,255,255,0.08))',
      marginRight: '4px',
    }}
    role="tablist"
  >
    {TABS.filter((t) => {
      if (t.id === 'cadeia-ajuda' || t.id === 'auditoria') return canAudit;
      if (t.id === 'diagnostico') return canAudit || canConfigure;
      if (t.id === 'configuracao') return canConfigure;
      return true;
    }).map((tab) => (
      <RibbonDesktopButton
        key={tab.id}
        icon={tab.icon}
        label={tab.label}
        active={screen === tab.id}
        onClick={() => onChange(tab.id)}
        title={tab.title}
      />
    ))}
  </div>
);

export default LstScreenTabs;
